import BaseApi from './base/BaseApi';

/**
 * Карточка поставщика (ТЗ 4.2 «Моя карточка», 4.4 «Поставщики: список, создать, изменить»).
 * Список и создание доступны администратору, чтение и правка контактов — самому поставщику;
 * операции удаления нет (У36), поэтому базовый `delete` здесь не используется.
 * Сгенерировано Claude.
 */
export default class SupplierApi extends BaseApi {
  static entityName = 'suppliers';
}
